import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Button,
  Label,
  Input
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";

// Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";

const ChooseTopic = ({ t }) => {
  document.title = "選擇主題 | TheChart.AI";

  const [topicId, setTopicId] = useState("");
  const navigate = useNavigate();

  const handleGo = () => {
    if (topicId.trim()) {
      navigate(`/myInfo/testTopics/${topicId.trim()}`);
    }
  };

  return (
    <div className="page-content">
      <Container fluid>
        {/* Breadcrumb */}
        <Breadcrumbs title={t("我的資訊")} breadcrumbItem={t("選擇主題")} />

        <Card style={{ minHeight:"30rem" }}>
          <CardBody>
            <CardTitle className="mb-4">{t("輸入要測試的主題 ID")}</CardTitle>

            <Row 
              style={{ 
                display: "flex",
                flexDirection: "column",
                alignContent: "center",
                justifyContent: "center",
                margin: "0rem 1rem",
                minHeight: "20rem",
              }}
            >
              <Col xs="10" md="8" xl="12" 
                style={{ display: "flex", flexDirection: "column", flexDirection: "row", justifyContent: "center" }}
              >

                <Row style={{ margin: "0 auto", minWidth: "50%" }}>
                  <Col xs={12} xl={8} className="mb-3 mb-xl-0"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center"
                    }}
                  >
                    <Input
                      type="text"
                      id="topicIdInput"
                      value={topicId}
                      onChange={(e) => setTopicId(e.target.value)}
                      placeholder="請輸入主題 ID..."
                    />
                  </Col>
                  <Col xs={12} xl={4} className="text-end text-xl-start">
                    <Button
                      color="primary"
                      onClick={handleGo}
                      style={{ padding: "10px 16px" }}
                    >
                      <i className="bx bx-right-arrow-circle me-2"></i>
                      {t("前往填寫")}
                    </Button>
                  </Col>
                </Row>

              </Col>
            </Row>


          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

ChooseTopic.propTypes = {
  t: PropTypes.func,
};

export default withTranslation()(ChooseTopic);
